import { AppErrors } from "../constants/AppErrors";
import { IAppError } from "../interfaces/IAppError";

export class AppError extends Error implements IAppError {
    public code: string;
    public isUserFacing: boolean;
    public statusCode?: number;
    public metadata?: Record<string, any>;

    constructor(
        {
            message = AppErrors.UNEXPECTED_CLIENT_ERROR.message,
            statusCode = AppErrors.UNEXPECTED_CLIENT_ERROR.statusCode,
            code = AppErrors.UNEXPECTED_CLIENT_ERROR.code,
            isUserFacing = AppErrors.UNEXPECTED_CLIENT_ERROR.isUserFacing,
            metadata
        }: {
            message: string;
            statusCode?: number;
            code?: string;
            isUserFacing?: boolean;
            metadata?: Record<string, any>;
        }
    ) {
        super(message);
        this.statusCode = statusCode;
        this.code = code;
        this.isUserFacing = isUserFacing;
        this.metadata = metadata;
        Error.captureStackTrace(this, this.constructor);
    }
}
